import request from './request'

// 添加公司收藏
export function addFavoriteCompany(data) {
  return request({
    url: '/api/company/favorite/add',
    method: 'post',
    data
  })
}

// 取消公司收藏
export function cancelFavoriteCompany(data) {
  return request({
    url: '/api/company/favorite/cancel',
    method: 'post',
    data
  })
}

// 获取收藏公司列表
export function getFavoriteCompanyList(params) {
  return request({
    url: '/api/company/favorite/list',
    method: 'get',
    params
  })
}

// 检查公司是否收藏
export function checkFavoriteCompany(companyId) {
  return request({
    url: `/api/company/favorite/check/${companyId}`,
    method: 'get'
  })
}

